import React from 'react';
import './style.scss';
import { API_NftDetails } from 'shared';
import clsx from 'clsx';
import SocialButtons from '../../../../../../general/socialIcons';
import MarketPageDescBlock from '../../../../../marketPage/description/block';
import MarketPageActionHint from '../../../../../marketPage/actionHint';
import { MarketNftStatuses } from '../../../../../marketPage/Interfaces';

interface Props {
  nft: API_NftDetails | undefined;
  loading?: boolean;
  error: boolean;
  noAvail: boolean;
}

const LandingMintSectionNftDesc = ({ nft, loading, error, noAvail }: Props) => {
  return (
    <div className={clsx('lmis-nft-desc', loading && 'lmis-nft-desc-loading')}>
      <Inner nft={nft} error={error} noAvail={noAvail} />
    </div>
  );
};

const Inner = ({ nft, error, noAvail }: Props) => {
  const ph = '???';

  if (error) {
    return (
      <div className='lmis-nft-desc-block'>
        <p>Error:</p>
        <h4>Can't load available NFTs</h4>
      </div>
    );
  }

  if (noAvail) {
    return (
      <div className='lmis-nft-desc-block'>
        <h3>Sold out!</h3>
        <h4 style={{ marginBottom: 30 }}>
          Follow us in socials to catch new NFT coming
        </h4>
        <SocialButtons />
      </div>
    );
  }

  return (
    <>
      <MarketPageDescBlock
        title='Name'
        value={nft ? nft.name : ph}
        className='lmis-nft-desc-block'
      />
      <MarketPageDescBlock
        title='CLAN'
        value={nft ? nft.guild : ph}
        className='lmis-nft-desc-block'
      />
      <MarketPageActionHint
        status={MarketNftStatuses.AVAILABLE}
        price={nft ? nft.price : ph}
        className='lmis-nft-desc-block'
      />
    </>
  );
};

export default LandingMintSectionNftDesc;
